import { render, staticRenderFns } from "./BackofficeLayout.vue?vue&type=template&id=4367a40f&scoped=true&"
import script from "./BackofficeLayout.vue?vue&type=script&lang=js&"
export * from "./BackofficeLayout.vue?vue&type=script&lang=js&"
import style0 from "./BackofficeLayout.vue?vue&type=style&index=0&id=4367a40f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4367a40f",
  null
  
)

export default component.exports